// extracted by mini-css-extract-plugin
module.exports = {"columnsSection":"ColumnsSection_columnsSection__XZh_l","columns":"ColumnsSection_columns__H2PYb","grid":"ColumnsSection_grid__eTW9P"};